module.exports = __webpack_public_path__ + "static/media/cat_comics.e4d966c6.jpg";